import React, {useRef} from "react";
import {Table, Tooltip, Popconfirm, DefaultTablePagination} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import {useDispatch} from "react-redux";
import moment from "moment";
import {guestFeedbackListFxn, deleteGuestFeedbackFxn} from "./actions";

function GuestFeedbackList() {
    let dispatch = useDispatch();
    let tableRef = useRef();

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                const data = await guestFeedbackListFxn({
                    ...params,
                    regExFilters: ["name", "contact", "email"]
                });
                resolve(data);
            } catch (error) {
                console.error("Error fetching guest feedback:", error);
            }
        });
    };

    const deleteGuestFeedback = async (_id) => {
        let x = await dispatch(deleteGuestFeedbackFxn(_id));
        if (x && x.success && tableRef.current) {
            tableRef.current.reload();
        }
    };

    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            render: (text) => text || "-",
        },
        {
            title: "Contact",
            dataIndex: "contact",
            key: "contact",
            render: (text) => text || "-",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            render: (text) => text || "-",
        },
        {
            title: "Visit Type",
            dataIndex: "visitType",
            key: "visitType",
            render: (text) => text || "-",
        },
        // {
        //     title: "Service",
        //     dataIndex: "serviceQuality",
        //     key: "serviceQuality",
        //     render: (text) => text ?? "-",
        // },
        {
            title: "Service",
            dataIndex: "serviceQuality",
            key: "serviceQuality",
            render: (value) => {
                if (!value) return "-";

                return (
                    <div>
                       <span>
                            {value}
                           <i className="fa fa-star"
                              style={{color: "#f5a623", marginLeft: 5}}
                           />
                       </span>
                    </div>
                );
            },
        },
        {
            title: "Food",
            dataIndex: "foodQuality",
            key: "foodQuality",
            render: (value) => {
                if (!value) return "-";

                return (
                    <div style={{fontWeight: "500"}}>
                       <span>
                           {value}
                           <i className="fa fa-star"
                              style={{color: "#f5a623", marginLeft: 5}}
                           />
                       </span>
                    </div>
                );
            }
        },
        {
            title: "Overall",
            dataIndex: "overallExperience",
            key: "overallExperience",
            render: (value) => {
                if (!value) return "-";
                return (
                    <div style={{fontWeight: "500"}}>
                       <span>
                           {value}
                           <i className="fa fa-star"
                              style={{color: "#f5a623", marginLeft: 5}}
                           />
                       </span>
                    </div>
                );
            }
        },
        {
            title: "Ambience",
            dataIndex: "ambience",
            key: "ambience",
            render: (value) => {
                if (!value) return "-"
                return (
                    <div style={{fontWeight: "500"}}>
                       <span>
                           {value}
                           <i className="fa fa-star"
                              style={{color: "#f5a623", marginLeft: 5}}
                           />
                       </span>
                    </div>
                )

            }
        },
        {
            title: "Message",
            dataIndex: "message",
            key: "message",
            render: (text) => (
                <div style={{maxWidth: "250px", whiteSpace: "normal"}}>
                    {text || "-"}
                </div>
            ),
        },
        {
            title: "Date",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => (text ? moment(text).format("DD-MM-YYYY hh:mm A") : "-"),
        },
        // {
        //     title: "Action",
        //     dataIndex: "action",
        //     key: "action",
        //     render: (v, item) => {
        //         return (
        //             <Tooltip title="Delete">
        //                 <Popconfirm
        //                     title="Delete Guest Feedback?"
        //                     okText="Yes"
        //                     cancelText="No"
        //                     onConfirm={() => deleteGuestFeedback(item._id)}
        //                 >
        //                     <a className="empty_btn ml-2">
        //                         <i className="fa fa-trash" />
        //                     </a>
        //                 </Popconfirm>
        //             </Tooltip>
        //         );
        //     },
        // },
    ];

    return (
        <PageHeader title={"Guest Feedback"}>
            <div className="card mb-0">
                <div className="table-responsive">
                    <Table
                        apiRequest={apiRequest}
                        columns={columns}
                        pagination={DefaultTablePagination()}
                        ref={tableRef}
                    />
                </div>
            </div>
        </PageHeader>
    );
}

export default GuestFeedbackList;
